import { apiFetch } from "./api";
import { BASE_URL as u } from "../commonUrls";

const BASE_URL = `${u}/planner`;

const encodeCsv = (values) => {
  if (!values || values.length === 0) return "";
  return values.join(",");
};

export const getCalendarEvents = async (start, end, filters = {}) => {
  const types = encodeCsv(filters.types);
  const categories = encodeCsv(filters.categories);
  const includeInactive = Boolean(filters.includeInactive);
  const includeRecurring =
    typeof filters.includeRecurring === "boolean" ? filters.includeRecurring : true;

  const qs = new URLSearchParams({
    start,
    end,
    types,
    categories,
    includeInactive: String(includeInactive),
    includeRecurring: String(includeRecurring),
  });

  const res = await apiFetch(`${BASE_URL}/calendar?${qs.toString()}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

const normalizeTime = (value) => {
  if (!value) return null;
  return value.length === 5 ? `${value}:00` : value;
};

export const updatePlannerDate = async (id, date, startTime, endTime, allDay) => {
  const payloadDate = date ? date.slice(0, 10) : date;
  const res = await apiFetch(`${BASE_URL}/${id}/date`, {
    method: "PATCH",
    body: JSON.stringify({
      date: payloadDate,
      startTime: normalizeTime(startTime),
      endTime: normalizeTime(endTime),
      allDay,
    }),
  });
  return res.json();
};

export const getAttendees = async () => {
  const res = await apiFetch(`${u}/user/attendees`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const getGoogleCalendarEvents = async (start, end) => {
  const qs = new URLSearchParams({ start, end });
  const res = await apiFetch(`${u}/calendar/google/events?${qs.toString()}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const skipRecurringOccurrence = async (baseId, date) => {
  const payloadDate = date ? date.slice(0, 10) : date;
  const qs = new URLSearchParams({ date: payloadDate });
  const res = await apiFetch(`${BASE_URL}/${baseId}/recurrence/skip?${qs.toString()}`, {
    method: "POST",
  });
  return res.ok;
};

export const exportIcs = async (start, end, filters = {}) => {
  const types = encodeCsv(filters.types);
  const categories = encodeCsv(filters.categories);
  const includeInactive = Boolean(filters.includeInactive);
  const includeRecurring =
    typeof filters.includeRecurring === "boolean" ? filters.includeRecurring : true;

  const qs = new URLSearchParams({
    start,
    end,
    types,
    categories,
    includeInactive: String(includeInactive),
    includeRecurring: String(includeRecurring),
  });

  const res = await apiFetch(`${u}/calendar/ics/export?${qs.toString()}`);
  if (!res.ok) throw new Error("export failed");
  return res.blob();
};

export const importIcs = async (file, defaults = {}) => {
  const form = new FormData();
  form.append("file", file);
  if (defaults.defaultType) form.append("defaultType", defaults.defaultType);
  if (defaults.defaultCategory) form.append("defaultCategory", defaults.defaultCategory);
  const res = await apiFetch(`${u}/calendar/ics/import`, {
    method: "POST",
    body: form,
  });
  if (!res.ok) throw new Error("import failed");
  return res.json();
};
